import React from "react"
import api from "src/api"
import { buildSearchFilter } from "src/utils/build-search-filter"
import {getEventHints, getProductCategories} from "src/utils"

// Поиск: по названию частично, по ID точно (префикс = включает точное сравнение).
const SEARCH_FIELDS = ["=id", "name->>'ru'"]

export function useGetData() {
  const [dataItemsColumns, setDataItemsColumns] = React.useState([])
  const [dataItems, setDataItems] = React.useState([])

  const [isLoading, setIsLoading] = React.useState(false)
  const [pagination, setPagination] = React.useState(null)
  const [appliedFilters, setAppliedFilters] = React.useState("")

  const [ rewardTypesOptions, setRewardTypesOptions] = React.useState([])
  const [ eventOptions, setEventOptions ] = React.useState([]);

  React.useEffect(() => {
    getRewardTypes()
    getEventOptions()
    getItems()
  }, [])

  const getItems = (page = 1, countOnPage = 20, filters = appliedFilters) => {
    setIsLoading(true)
    api.get(`loyalty-rewards?page=${page}&countOnPage=${countOnPage}${filters}`).then(({ data }) => {
      setPagination({
        current: data.pagination.currentPage,
        pageSize: data.pagination.countOnPage,
        total: data.pagination.total,
      })
      const columnsItems = getFormattedItems(data.items)
      setDataItemsColumns(columnsItems)
      setDataItems(data.items)
    })

    setIsLoading(false)
  }

  async function getRewardTypes() {
    api.get("task-reward-types").then(({ data }) => {
      const options = []
      data.items.forEach((item) => {
        options.push({
          label: item.name,
          value: item.id
        })
      })
      setRewardTypesOptions(options)
    })
  }

  async function getEventOptions() {
    const events = getEventHints()
    events.then(( data ) => {
      const options = []
      data.forEach((item) => {
        options.push({
          label: item.name,
          value: item.id,
        })
      })
      setEventOptions(options)
    })
  }

  function handleTableChange(pagination) {
    getItems(pagination.current, pagination.pageSize, appliedFilters)
  }

  function handleSearchTable(value) {
    const filters = buildSearchFilter(value, SEARCH_FIELDS)
    setAppliedFilters(filters)
    getItems(1, pagination?.pageSize || 20, filters)
  }

  function getFormattedItems(items) {
    const newItems = []

    items.forEach((item) => {
      let newItem = {
        key: item.id,
        id: item.id,
        isActive: item.isActive,
        name: item.name.find((el) => el.language === "ru").content,
        description: item.description.find((el) => el.language === "ru").content,
      }
      newItems.push(newItem)
    })

    return newItems
  }

  return {
    dataItems,
    dataItemsColumns,
    pagination,
    isLoading,
    handleTableChange,
    handleSearchTable,
    refetch: () => getItems(),
    options: { rewardTypesOptions, eventOptions},
  }
}
